import React, { useState, useRef, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import Icon from "../../../Icon";
import styles from "../../../../css/form/multiselect.module.css";
import { classNames } from "../../../../utils/helpers";
import { MdErrorOutline } from "react-icons/md";
const MultiSelect = (props) => {
  const {
    options = [],
    value = [],
    onChange,
    title,
    required,
    isError,
    errors,
    disabled = false,
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggle = (selectedValue) => {
    const currentIndex = value.indexOf(selectedValue);
    const newItems = [...value];

    if (currentIndex === -1) {
      newItems.push(selectedValue);
    } else {
      newItems.splice(currentIndex, 1);
    }

    onChange(newItems);
  };

  const getSelectedLabels = useMemo(() => {
    if (!value || value.length === 0) {
      return `Seleccionar ${title}`;
    }

    const selectedOptions = options.filter((opt) => value.includes(opt.value));
    if (selectedOptions.length === 0) return `Seleccionar ${title}`;

    if (selectedOptions.length <= 2) {
      return selectedOptions.map((opt) => opt.label).join(", ");
    }

    return `${selectedOptions.length} seleccionados`;
  }, [options, value, title]);

  return (
    <div className="flex flex-col py-2 w-full relative" ref={dropdownRef}>
      <label className="text-gray-700 font-semibold text-sm flex justify-start align-top mb-2">
        {title}
        {required && <span className="text-red-700 mx-1">*</span>}
      </label>

      <button
        className={classNames(
          styles.multiselect,
          isError && styles.error,
          disabled && styles.disabled
        )}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
      >
        <span className="text-1rem truncate font-[400]">
          {getSelectedLabels}
        </span>
        <div className="flex justify-end gap-2 items-center">
          {isError && errors && (
            <MdErrorOutline size={20} className="text-[#DC3545]" />
          )}

          <div className="transition-all duration-300 flex items-center">
            <Icon icon={isOpen ? "expand_less" : "expand_more"} size={24} />
          </div>
        </div>
      </button>

      {isOpen && !disabled && (
        <div className="absolute top-20 left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg z-50 max-h-[600px] overflow-y-auto">
          {options.length === 0 ? (
            <div className="text-gray-500 text-sm px-3 py-2">
              No hay opciones disponibles
            </div>
          ) : (
            <>
              {options.map((option) => (
                <div
                  key={option.value}
                  className={classNames(
                    `flex items-center px-3 py-2 cursor-pointer hover:bg-gray-100 first:opacity-50 first:cursor-not-allowed first:pointer-events-none first:bg-gray-200`,
                    {
                      "bg-blue-200": value.includes(option.value),
                    }
                  )}
                  onClick={() => handleToggle(option.value)}
                >
                  <span>{option.label}</span>
                </div>
              ))}
            </>
          )}
        </div>
      )}

      {isError && errors && (
        <div className="text-[#DC3545] text-[14px] mt-1">{errors}</div>
      )}

      {/* {value.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-1">
          {options
            .filter((opt) => value.includes(opt.value))
            .map((opt) => (
              <span
                key={opt.value}
                className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
              >
                {opt.label}
                <button
                  type="button"
                  className="border-none !bg-transparent ml-1 text-gray-600 hover:bg-blue-500 focus:outline-none"
                  onClick={() => {
                    const newItems = value.filter((v) => v !== opt.value);
                    onChange(newItems);
                  }}
                >
                  ×
                </button>
              </span>
            ))}
        </div>
      )} */}
    </div>
  );
};

MultiSelect.propTypes = {
  options: PropTypes.array,
  name: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func,
  title: PropTypes.string,
  required: PropTypes.bool,
  isError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  errors: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

export default MultiSelect;
